import React from 'react';
import i18n from '@i18next/i18n';
import { Feature } from '@tencent/workbench';
import Menu from '@tencent/dui/lib/components/Menu';
import BaseGridFeature from '@framework/workbench/common/feature/base-grid-feature';
import { config } from './config';
import { TOOLBAR_ITEMNUMBER } from '@editor/src/img/pageIndex';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { CharacterTypes } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/character-type';
import { SOURCE_ID } from '@src/slide/application/service/bullets-and-numbering-dialog-manager/core/constant';

@Feature()
export class ItemNumberFeature extends BaseGridFeature {
    id = config.id;
    config = config;

    public getBottomSlot() {
        return (
            <Menu.Item
                style={{ padding: '9px 11px' }}
                icon={TOOLBAR_ITEMNUMBER}
                onClick={this.handleOpen}
            >
                {i18n.t('项目符号和编号')}
            </Menu.Item>
        );
    }

    /**
     * 复写父类的方法，获取当前选中项目符号的索引
     * @returns
     */
    public getSelectedIndex() {
        const { dropdown } = this.config;
        if (!dropdown?.checkSelectedValue) {
            return -1;
        }
        const selectedType = this.getSelectedType();
        if (!selectedType) {
            return -1;
        }
        return dropdown.getData().findIndex(item => selectedType === item.id);
    }

    /**
     * 获取当前选中的项目符号的类型
     * @returns
     */
    private getSelectedType() {
        const type = this.getItemValue();
        if (type) {
            return type;
        }
        const customText = this.getItemValue(ActionType.BULLET_CUSTOM_TEXT);
        if (customText) {
            return CharacterTypes.CUSTOM_TEXT;
        }
        const customImage = this.getItemValue(ActionType.BULLET_CUSTOM_IMAGE);
        if (customImage) {
            return CharacterTypes.CUSTOM_IMAGE;
        }
    }

    private handleOpen = () => {
        this.getAppService().editableServiceLayer?.bulletsAndNumberingDialogManager
            .promise().then((bulletsAndNumberingDialogManager) => {
                bulletsAndNumberingDialogManager.showDialog(config.id, SOURCE_ID.toolBarBullet);
            });
    };
}
